/**
 * Initial state for the department module.
 *
 * @module store/modules/department/state
 */
import { DepartmentState } from "./types";

const state: DepartmentState = {
  departments: [],
  createLoading: false,
};

export default state;
